export const defaultColors = {
  topBarBackground: "#ffffff",
  topBarTint: "#000000",
  topBarText: "#000000",
  wallBackground: "#ffffff",
  wallTint: "#000000",
  wallText: "#000000",
  wallDetail: "#000000",
  postBackground: "#ffffff",
  postTint: "#000000",
  postText: "#000000",
  postDetail: "#000000"
}
